import { COLUMN_WIDTHS } from "../../constants/ApplicationConstants";
import { Icon } from "@vds/icons";

const wheelChair = (
  <Icon
    className="trash-icon"
    aria-label="InternationalSymbolOfAccess"
    alt="InternationalSymbolOfAccess"
    name="international-symbol-of-access"
    size="XLarge"
    style={{ cursor: "pointer", outline: "none", width: "1.3rem", blockSize: "1.3rem" }}
    color="#000000"
  />
);
const killSwitch = (
  <Icon
    className="smart-switch"
    aria-label="smart-switch"
    alt="smart-switch"
    name="smart-switch"
    size="Large"
    color="#000000"
    style={{ cursor: "pointer", outline: "none", width: "1.3rem", blockSize: "1.3rem" }}
  />
);

const ambulance = (
  <Icon
    className="police-fleet"
    aria-label="police-fleet"
    alt="police-fleet"
    name="police-fleet"
    size="Large"
    color="#000000"
    style={{ cursor: "pointer", outline: "none", width: "1.3rem", blockSize: "1.3rem" }}
  />
);

export const ADD_VEHICELS_ASSIGNMENT_LIST_COLS = [
  {
    key: "VIN",
    value: "vin",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "170px",
  },
  {
    key: "Year",
    value: "year",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "70px",
  },
  {
    key: "Make",
    value: "make",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "80px",
  },
  {
    key: "Model",
    value: "model",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "80px",
  },
  {
    key: "Class",
    value: "weightClass",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "80px",
  },
  {
    key: "Error",
    value: "error",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    width: "81px",
  },
  {
    key: wheelChair,
    value: "wheelChair",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isHyperLink: false,
    isCheckboxes: true,
    width: "45px",
  },
  {
    key: killSwitch,
    value: "killSwitch",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isCheckboxes: true,
    isHyperLink: false,
    width: "45px",
  },
  {
    key: ambulance,
    value: "emergency",
    isFilterEnabled: false,
    filterType: "String",
    isCustomFilter: false,
    isSortable: true,
    isCheckboxes: true,
    isHyperLink: false,
    width: "45px",
  },
];
